import React from 'react';
import { Avatar, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface UserMessageProps {
  message: string;
  index: number;
}

export const UserMessage: React.FC<UserMessageProps> = ({ message, index }) => (
  <div className="message user-message" data-message-index={index}>
    <div className="message-content">
      <Text className="message-text">
        {message}
      </Text>
    </div>
    <Avatar className="message-avatar">
      <UserOutlined style={{ color: 'white' }} />
    </Avatar>
  </div>
);
